module.exports = __webpack_public_path__ + "img/bank-effect-switch.6695f5b0.svg";